/**
 * Utility exports for structured data package
 */

// Cache utilities
export { LRUCache, DurationCache } from './cache';
export type { CacheOptions } from './cache';

// Result pattern for error handling
export { ok, fail, isOk, isFail, mapResult, chainResult, unwrapOr, tryCatch, combineResults } from './result';
export type { Result, Success, Failure } from './result';

// Validation utilities
export {
    safeNumber,
    safeString,
    isValidUrl,
    stripHtmlTags,
    toAbsoluteUrl,
    validateBatch,
    isValidEmail,
    isValidPhoneNumber,
    isValidCountryCode,
} from './validation';
export type { ValidationError } from './validation';
